import type { RouteRecordRaw } from 'vue-router'

export const AuthRoutes: Array<RouteRecordRaw> = [
  {
    path: '/auth',
    component: () => import('@/layouts/auth-layout.vue'),
    meta: { isAuthRoute: true },
    children: [
      {
        path: '',
        name: 'sign-in',
        meta: { title: 'ورود به گو تو ترین' },
        component: () => import('@/views/auth/sign-in.vue')
      },
      {
        path: 'create-account',
        name: 'create-account',
        component: () => import('@/views/auth/create-account.vue')
      },
      {
        path: 'sign-with-password',
        name: 'sign-with-password',
        component: () => import('@/views/auth/sign-with-password.vue')
      }
    ]
  }
]
